import BlogPost from '~/components/Blog/BlogPostColors'

export default function BlogColorsPage() {
  return <BlogPost />
}